import React from 'react';

/**
 * Switch
 *
 * Custom toggle switch implementing the design system .switch specification.
 * Replaces native <input type="checkbox"> for toggles.
 */
export default function Switch({
  checked = false,
  onChange,
  disabled = false,
  id,
  name,
  'aria-label': ariaLabel,
  className = '',
}) {
  const handleClick = (e) => {
    e.preventDefault();
    if (disabled || !onChange) return;
    onChange(!checked);
  };

  const handleKeyDown = (e) => {
    if (disabled || !onChange) return;
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      id={id}
      name={name}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`switch ${checked ? 'on' : ''} ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      } ${className}`}
    />
  );
}
